import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import React from 'react';
import fr from 'facet-rest';
import { NavButton } from 'Components/ClientApp/CombinedApp/Navigation/NavButton';
import { buildClientLink } from 'Views/Page/Content/Templates';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import useMobileLayout from 'Hooks/useMobileLayout';

export const ReferralPageNavButton = () => {
  const { householdResource } = useSimpleHousehold();
  const isMobile = useMobileLayout();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const onButtonClick = () => {
    logStandardizedEvent(categories.referralPage,
      eventTypes.navigateTo,
      `Referral Page - Navigated to Referral Page via New Nav on ${isMobile ? 'mobile' : 'desktop'}`);
  };

  return householdResource.withRelationship(fr.relationships.referralPage.name,
    (rel) => (
      <NavButton
        value="referralPage"
        to={buildClientLink(rel.link('related'))}
        onClick={onButtonClick}
        label={rel.meta('prompt')}
        badge={{
          test: 'nav-referral-page-new-badge',
          content: rel.meta('badgeText'),
        }}
      />),
    () => null);
};
